<template>
	<div class="clearfix">
		<a-upload name="fileName" :action="uploadImgUrl" list-type="picture-card" :file-list="fileList" :before-upload="handleBeforeUpload" @preview="handlePreview" @change="uploadHandleChange" :headers="headers">
			<div v-if="fileList.length < limit">
				<a-icon type="plus" />
				<div class="ant-upload-text">
					上传
				</div>
			</div>
		</a-upload>

		<!-- 上传提示 -->
		<div class="ant-upload-text" v-if="showTip">
			请上传
			<template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
			<template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
			的文件
			<template v-if="limit"> 最多上传 <b style="color: #f56c6c">{{ limit }}</b> 张图片 </template>
		</div>

		<a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
			<img alt="example" style="width: 100%" :src="previewImage" />
		</a-modal>
	</div>
</template>

<script>
	function getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		});
	}

	export default {
		props: {
			value: [String, Object, Array],
			// 图片数量限制
			limit: {
				type: Number,
				default: 5,
			},
			// 大小限制(MB)
			fileSize: {
				type: Number,
				default: 5,
			},
			// 文件类型, 例如['png', 'jpg', 'jpeg']
			fileType: {
				type: Array,
				default: () => ["png", "jpg", "jpeg"],
			},
			// 是否显示提示
			isShowTip: {
				type: Boolean,
				default: true
			},
			// 是否禁用
			disabled: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				number: 0,
				baseUrl: this.navigation && this.navigation.url ? this.navigation.url : '',
				uploadImgUrl: "", // 上传的图片服务器地址
				headers: {
					userToken: window.sessionStorage.getItem('token')
				},
				fileList: [],
				loading: false,
				loadingMessage: null,
				previewVisible: false,
				previewImage: '',
			};
		},
		created() {
			if (this.navigation && this.navigation.apiUploadFiles) {
				this.uploadImgUrl = this.navigation.apiUploadFiles;
			}
		},
		watch: {
			value: {
				handler(val) {
					if (val) {
						// 首先将值转为数组
						const list = Array.isArray(val) ? val : this.value.split(',');
						// 然后将数组转为对象数组
						this.fileList = list.map((item, index) => {
							if (typeof item === "string") {
								const baseUrl = this.navigation && this.navigation.url ? this.navigation.url : '';
								if (item.indexOf(baseUrl) === -1) {
									item = {
										uid: `init_${index}_${Date.now()}`, // 生成唯一uid
										name: baseUrl + item,
										url: baseUrl + item
									};
								} else {
									item = {
										uid: `init_${index}_${Date.now()}`, // 生成唯一uid
										name: item,
										url: item
									};
								}
							} else if (!item.uid) {
								// 为已存在的对象添加uid（如果没有的话）
								item.uid = `init_${index}_${Date.now()}`;
							}
							return item;
						});
					} else {
						this.fileList = [];
						return [];
					}
				},
				deep: true,
				immediate: true
			}
		},
		computed: {
			// 是否显示提示
			showTip() {
				return this.isShowTip && (this.fileType || this.fileSize);
			},
		},
		methods: {
			// 上传前loading加载
			handleBeforeUpload(file) {
				// 检查文件数量限制
				if (this.fileList.length >= this.limit) {
					this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
					return false;
				}

				let isImg = false;
				if (this.fileType.length) {
					let fileExtension = "";
					if (file.name.lastIndexOf(".") > -1) {
						fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
					}
					isImg = this.fileType.some(type => {
						if (file.type.indexOf(type) > -1) return true;
						if (fileExtension && fileExtension.indexOf(type) > -1) return true;
						return false;
					});
				} else {
					isImg = file.type.indexOf("image") > -1;
				}

				if (!isImg) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`);
					return false;
				}
				if (this.fileSize) {
					const isLt = file.size / 1024 / 1024 < this.fileSize;
					if (!isLt) {
						this.$message.error(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
						return false;
					}
				}
				this.loading = true;
				this.loadingMessage = this.$message.loading("正在上传图片，请稍候...", 0);
				this.number++;
			},

			// 上传成功回调
			handleUploadSuccess(res, file) {
				if (res.code === 200) {
					const baseUrl = this.navigation && this.navigation.url ? this.navigation.url : '';
					const fullUrl = baseUrl + res.data;
					// 更新当前文件的URL
					// const updatedFile = { ...file, url: fullUrl, status: 'done' };
					const updatedFile = {
						uid: file.uid,
						name: file.name,
						url: fullUrl,
						status: 'done'
					};


					// 更新fileList
					const index = this.fileList.findIndex(f => f.uid === file.uid);
					if (index > -1) {
						this.fileList[index] = updatedFile;
					} else {
						this.fileList.push(updatedFile);
					}
					// 通知父组件
					this.$emit("input", this.listToString(this.fileList));
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false;
				this.loadingMessage && this.loadingMessage();
				this.loadingMessage = null;
			},
			// 删除图片
			handleDelete(file) {
				// // 使用uid来查找和删除文件，因为uid是唯一的
				// const findex = this.fileList.findIndex(f => f.uid === file.uid);
				// console.log(findex)
				// if (findex > -1) {
				//   this.fileList.splice(findex, 1);
				//   this.$emit("input", this.listToString(this.fileList));
				// }
				this.$emit("input", this.listToString(this.fileList));

			},
			// 上传失败
			handleUploadError(res, file) {
				this.loadingMessage && this.loadingMessage();
				const errorMsg = res && res.msg ? res.msg : "上传图片失败，请重试";
				this.$message.error(errorMsg);
				this.loading = false;
				this.loadingMessage = null;
			},
			// 上传状态变化处理
			uploadHandleChange(info) {
				const {
					file,
					fileList,
					event
				} = info;
				const status = file.status;

				// 更新组件的fileList
				this.fileList = fileList;

				if (status === 'uploading') {
					// 上传中，可以在这里处理上传进度等信息
					if (event && event.percent !== undefined) {
						// 可以在这里显示上传进度
					}
				} else if (status === 'done') {
					// 上传成功
					this.handleUploadSuccess(file.response, file);
				} else if (status === 'error') {
					// 上传失败
					this.handleUploadError(file.response, file);
				} else if (status === 'removed') {
					// 文件被移除
					this.handleDelete(file);
				}
			},
			handleCancel() {
				this.previewVisible = false;
			},
			// 预览
			async handlePreview(file) {
				if (!file.url && !file.preview) {
					file.preview = await getBase64(file.originFileObj);
				}
				this.previewImage = file.url || file.preview;
				this.previewVisible = true;
			},

			// 对象转成指定字符串分隔
			listToString(list, separator) {
				let strs = "";
				separator = separator || ",";
				for (let i in list) {
					if (list[i].url) {
						strs += list[i].url.replace(this.baseUrl, "") + separator;
					}
				}
				return strs != '' ? strs.substr(0, strs.length - 1) : '';
			}
		}
	};
</script>

<style scoped lang="scss">
	// .ant-upload-picture-card 控制加号部分
	::v-deep.hide .ant-upload-picture-card-wrapper {
		display: none;
	}

	// 去掉动画效果
	::v-deep .ant-list-enter-active,
	::v-deep .ant-list-leave-active {
		transition: all 0s;
	}

	::v-deep .ant-list-enter,
	.ant-list-leave-active {
		opacity: 0;
		transform: translateY(0);
	}

	// .ant-upload-select-picture-card i {
	//   font-size: 32px;
	//   color: #999;
	// }

	// .ant-upload-select-picture-card .ant-upload-text {
	//   margin-top: 8px;
	//   color: #666;
	// }
</style>